import type { SVGProps } from "react";

/**
 * google
 * @category Social Media & Brands
 */
export default function IconGoogle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M21.5844 12.2273C21.5844 11.5182 21.5208 10.8363 21.4026 10.1818H11.9844V14.0545H17.3662C17.1298 15.3 16.4207 16.3545 15.3571 17.0636V19.5818H18.6026C20.4935 17.8363 21.5844 15.2727 21.5844 12.2273Z'
        fill='currentColor'
      />
      <path
        d='M11.982 22C14.682 22 16.9456 21.1091 18.6002 19.5818L15.3547 17.0636C14.4638 17.6636 13.3274 18.0273 11.982 18.0273C9.38197 18.0273 7.17287 16.2727 6.38196 13.9091H3.05469V16.4909C4.70014 19.7546 8.07288 22 11.982 22Z'
        fill='currentColor'
      />
      <path
        d='M6.38438 13.9C6.18438 13.3 6.0662 12.6636 6.0662 12C6.0662 11.3363 6.18438 10.7 6.38438 10.1V7.51816H3.0571C2.37528 8.86361 1.98438 10.3818 1.98438 12C1.98438 13.6182 2.37528 15.1364 3.0571 16.4818L5.64802 14.4636L6.38438 13.9Z'
        fill='currentColor'
      />
      <path
        d='M11.982 5.98182C13.4547 5.98182 14.7638 6.49091 15.8092 7.47273L18.6729 4.60909C16.9365 2.99091 14.682 2 11.982 2C8.07288 2 4.70014 4.24546 3.05469 7.51819L6.38196 10.1C7.17287 7.73637 9.38197 5.98182 11.982 5.98182Z'
        fill='currentColor'
      />
    </svg>
  );
}
